import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';

import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    TemplateRef,
    ViewChild,
    Inject
  } from "@angular/core";
  import { MatDialog } from "@angular/material";
  import { ActivatedRoute, Router } from "@angular/router";
  import { BlockUI, NgBlockUI } from "ng-block-ui";
  import { ToastrService } from "ngx-toastr";
  import { BehaviorSubject, forkJoin, Observable, of, Subscription } from "rxjs";
  import { Message } from "src/app/core/class/message";
  import { ErrorCode } from "src/app/core/constants/error-code";
  import { SCREEN_SIZE } from "src/app/core/constants/screen-size";
  import { CommonService } from "src/app/core/services/common.service";
  import { CertificateTypeID, Common, LIMIT_SIZE } from "src/app/core/constants/common";
  import { DigitalCertificateService } from "src/app/core/services/digital-certificate.service";
  import { DocumentService } from "src/app/core/services/document.service";
  import { NotificationService } from "src/app/core/services/notification.service";
  import { ResponsiveService } from "src/app/core/services/responsive.service";
  import { SignDocumentService } from "src/app/core/services/sign-document.service";
  import { BreadcrumbsService } from "src/app/shared/components/breadcrumbs/breadcrumbs.service";
  //import { AddDigitalCertificateComponent } from "../../digital-certificate/add-digital-certificate/add-digital-certificate.component";
  import { EnumSignMethod } from "src/app/core/constants/contract";
  import * as htmlToImage from "html-to-image";
  import { EnterpriseTypes } from "src/app/core/constants/enterprise-type";
  import { AlertComponent } from "src/app/shared/components/alert/alert.component";
  import { DomSanitizer } from "@angular/platform-browser";
  // @ts-ignore
  import { NzUploadFile } from "ng-zorro-antd/upload";
  import { CanvasService } from "src/app/core/services/canvas.service";
//   import {
//     ContentPosition,
//     SignatureConfig,
//   } from "./signature-config.model";
  import { map, switchMap, tap } from "rxjs/operators";
  import { SignPositionTypes } from 'src/app/core/constants/signposition-types';
  import { TranslateService } from '@ngx-translate/core';
  import { EnvService } from 'src/app/core/services/env.service';
  import { format } from 'date-fns';
  //import { SignDocumentComponent } from '../sign-document/sign-document.component';
  import { CanvasComponent } from 'src/app/shared/components/canvas/canvas.component';
  import FileUtils from 'src/app/core/services/file-utils';
  //import { ConfirmResignEkycSupportComponent } from '../confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
  //import { EkycCameraComponent } from '../ekyc/ekyc-camera/ekyc-camera.component';
  import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
  //import { SigningDialogComponent } from '../signing-dialog/signing-dialog.component';
  import * as _ from 'lodash';
  //import { ConfirmSignOtpWithImageComponent } from '../confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
  import { FormControl } from '@angular/forms';
  import { ApiService } from 'src/app/core/services/api.service';
  import { EnterpriseService } from 'src/app/core/services/enterprise.service';
  import { DeviceDetectorService } from 'ngx-device-detector';
  import { UsbTokenService } from 'src/app/core/services/usb-token.service';
  //import {ImageGenerateService} from "../../../../../../core/services/image-generate.service";
  //import { imageConfigFormPreviewId, imageConfigViewScaleId, ImageSignDigitalConfigComponent, transformContentPositionValue } from "./image-sign-digital-config/image-sign-digital-config.component";
  //import { imageConfigRenderId } from "../sign-flow-document/image-sign-config/image-sign-config.component";
  //import { SaveSessionCloudCaDialogComponent } from "../sign-flow-document-v2/save-session-cloud-ca-dialog/save-session-cloud-ca-dialog.component";
  import { NgxExtendedPdfViewerService, pdfDefaultOptions } from "ngx-extended-pdf-viewer";
  import { DigitalContractService } from "src/app/core/services/digital-contract.service";
  import { SigningDialogAuthenticationComponent} from '../../signing-dialog-authentication/signing-dialog-authentication.component';
import { UserService } from 'src/app/core/services/user.service';
  //import { DigitalCertificateService } from "src/app/core/services/digital-certificate.service";
//   import {
//     ContentPosition,
//     SignatureConfig,
//   } from "../../sig";


@Component({
  selector: 'app-sign-aunthentication-popup',
  templateUrl: './sign-aunthentication-popup.component.html',
  styles: [`
    .info-branch {
      font-family: Roboto, "Helvetica Neue", sans-serif;
    }
  `]
})

export class SignAuthenticationPopupComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  
enterpriseId: string = "";
userId: string = "";
enumSignMethod = EnumSignMethod;
document: any;
signImages: any = [];
signTransactionId: any;
signProcessing: any[] = [];
errorStatus: string;
signError: string = null;
isCancel: boolean = false;
isCallDone: boolean = false;
processingId: string = null;
messageData: string = null;

typeCertificate: any = this.enumSignMethod.CLOUD_CA;


imageCertificates: any[] = [];

  selectedCert: any = null;

  mediaBreakpoint: any;

  columnsToDisplay: string[] = [];
  columnDefinitions = [
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  columnsToDisplayOTP: string[] = [];
  columnDefinitionsOTP = [
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];

  columnsToDisplayCloudCA: string[] = [];
  columnDefinitionsCloudCA = [
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    // {
    //   def: "hasTransSaved",
    //   showXS: true,
    //   showSM: true,
    //   showMD: true,
    //   showLG: true,
    //   showXL: true,
    // },
  ];
  columnsToDisplayEasyCA: string[] = [];
  columnDefinitionsEasyCA = [
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "pin",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "isSavePin",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  
  
  certificates: any[] = [];
  isCertificateDefault: boolean = false;
  isHsmPermission: boolean = false;
  isHaveDataSignMethodHSM: boolean = false;
  isHaveDataSignMethodUSB: boolean = false;
  isHaveDataSignMethodSIM_CA: boolean = false;
  isHaveDataSignMethodCLOUD_CA: boolean = false;
  isHaveDataSignMethodEASY_CA: boolean = false;
  isHaveDataSignMethodOTP: boolean = false;
  certificateLastest: any;
  enterpriseInfo: any;
  allowOtp: boolean = false;
  validateCertificateSign: any = {
    certificateNo: "",
    representDocumentNumber: "",
    taxCode: "",
  };
  statusDocument: any;
  isUserSign: boolean = false;
//   signConfig: SignatureConfig = SignatureConfig.build();

  constructor(
    public dialogRef: MatDialogRef<SigningDialogAuthenticationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog ,
    private digitalCertificateService: DigitalCertificateService,
    private commonService : CommonService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    public messages: Message,
    private enterpriseService: EnterpriseService,
    private userService: UserService,
    private location: Location
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
    this.enterpriseId = localStorage.getItem("enterpriseId");
    this.statusDocument = data.statusDocument;
  }

  ngOnInit() {
    this.getDisplayedColumnsCloudCA();
    this.getInformationUser();
    this.getCertificates();
  }

  onNoClick() {
    this.dialog.closeAll();
    if (this.statusDocument == 4) return;
    if (this.location.path().includes('view-document-moha')) {
        this.location.back();
      }
    if (this.data && this.data.onAuthenCancel) {
      this.data.onAuthenCancel();
    }
  }

onClickSignButton() {
  if (!this.checkCertificateSign()) { return; }
  setTimeout(() => {
    const body = {
      certDetailId: this.selectedCert.idDetail,
      sessionId: this.commonService.generateUUID()
    };
    this.digitalCertificateService
      .signTindyAuthen(body)
      .subscribe((rs) => {
        
        if (rs) {
          if (!rs.success) {
            this.messageData = rs.message;
            this.documentService.messageData = this.messageData;
          }         
        }
      });
      this.dialogRef.close();
      this.dialogRef = this.dialog.open(SigningDialogAuthenticationComponent, {
        panelClass: 'signing-authentication',
        width: "80%",
        disableClose: true,
        data: body
      });

      this.dialogRef.afterClosed().subscribe((res) => {
        this.dialog.closeAll();
        if (res !== 3) {
          if (this.location.path().includes('view-document-moha')) {
            this.location.back();
          }
          if (this.data && this.data.onAuthenCancel) {
            this.data.onAuthenCancel();
          }
        } else if (this.data && this.data.onAuthenSuccess) {
          this.data.onAuthenSuccess();
        }
      });
  }, 0);


    // if (this.fileUpload) {
    //   this.sign = {
    //     ...this.sign,
    //     image: this.fileUpload,
    //   };
    // }

    // if (!this.isShowImage) {
    //   fetch("../../../../../../../assets/images/arrowLeft.png")
    //     .then((response) => response.blob())
    //     .then((blob) => {
    //       this.fileUpload = new File([blob], "fileNameGoesHere", {
    //         type: "image/png",
    //       });
    //       if (this.fileUpload) {
    //         this.onClickConfirmButtonImage();
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Lỗi khi đọc tệp ảnh", error);
    //     });
    // } else {
    //   if (!this.fileUpload) {
    //     this.onClickConfirmButton();
    //   } else {
    //     this.onClickConfirmButtonImage();
    //   }
    // }
    
  }
  
  // async selectCertificate(certificate) {
  //   this.selectedCert = certificate;
  // }
  getInformationUser(){
    this.enterpriseId = localStorage.getItem('enterpriseId') || '';
    this.userId = localStorage.getItem('userId') || '';
    forkJoin({
      enterprise: this.enterpriseService.getEnterpriseByID(this.enterpriseId),
      user: this.userId ? this.userService.getUser(this.userId) : of(null)
    }).subscribe(({ enterprise, user }) => {

      if (enterprise != null && enterprise.data != null && user != null && user.data != null) {
        if (enterprise.data.adminUser && user.data.userName && enterprise.data.adminUser.toUpperCase() === user.data.userName.toUpperCase()) {
          this.validateCertificateSign.certificateNo = enterprise.data.certificateNo || '';
          this.validateCertificateSign.taxCode = enterprise.data.taxCode || '';
          this.isUserSign = false;
        } else {
          this.validateCertificateSign.certificateNo = user.data.certificateNo || '';
          this.validateCertificateSign.taxCode = user.data.taxCode || '';
          this.isUserSign = true;
        }
      }
    });
  }
  

  checkCertificateSign(){
      if (this.isUserSign && !this.validateCertificateSign.certificateNo) {
        this.toastr.error(
          this.messages.getMessage(
            "messages.digital_certificate_validate_user"
          )
        );
        return false;
      }
      if (
        this.selectedCert.taxCode.length > 0 &&
        (this.selectedCert.taxCode.toUpperCase() ===
          this.validateCertificateSign.certificateNo.toUpperCase() ||         
          (this.validateCertificateSign.taxCode &&
            this.selectedCert.taxCode.toUpperCase() ===
              this.validateCertificateSign.taxCode.toUpperCase()))
      ) {
        return true;
      } else {
        this.toastr.error(
          this.messages.getMessage(
            "messages.digital_certificate_validate_taxCode_tindy"
          )
        );
        return false;
      }
    
  }

  getCertificates(isAfterAddCertificate?: boolean) {
    this.digitalCertificateService
      .getCertificates(this.enterpriseId)
      .subscribe((rs) => {
        // rs.data = null;
        this.imageCertificates = [];
        this.certificates = rs.data || [];
        this.certificates = this.certificates.filter(cer => cer.type == 10);
        this.isCertificateDefault = false;
        let indexCer = 0;
        let countList = -1;
        let indexList = 0;
        if (this.certificates.length > 0) {
          for (const cerType of this.certificates) {
            countList++;
            cerType.listCert = cerType.listCert.map((item, index) => {
              if (
                item.defaultCertificate &&
                !(item.typeCertificate === 0 && !this.isHsmPermission)
              ) {
                this.isCertificateDefault = true;
                indexCer = index;
                indexList = countList;
              }
              const { imagePath } = item;
              if (imagePath) {
                const imageDataBlob = this.commonService.b64toBlob(imagePath);
                const blobUrl = URL.createObjectURL(imageDataBlob);
                return {
                  ...item,
                  imageUrl: blobUrl,
                };
              } else {
                return {
                  ...item,
                  imageUrl: "",
                };
              }
            });
          }
          this.imageCertificates = [
            ...this.imageCertificates,
            ...this.certificates.filter((certificate) => {
              if (
                certificate.type === this.enumSignMethod.SIGN_SERVER &&
                !this.isHsmPermission
              ) {
                return false;
              }
              if (!this.allowOtp) {
                return (
                  Number(certificate.type) !== this.enumSignMethod.SIGN_OTP
                );
              } else return certificate;
            }),
          ];
          this.imageCertificates.forEach((cer) => {
            if (cer.type === this.enumSignMethod.EASY_CA) {
              if (cer.listCert.length > 0) {
                cer.listCert.forEach((element) => {
                  element.passwordVisibility = false;
                  if (element.pin && element.pin.length > 0) {
                    element.isSavePin = true;
                  } else {
                    element.isSavePin = false;
                  }
                });
              }
            }
          });

          // this.isHaveDataSignMethodHSM = !!this.imageCertificates.filter(
          //   (cretificate) =>
          //     cretificate.type === this.enumSignMethod.SIGN_SERVER
          // ).length;
          this.isHaveDataSignMethodUSB = !!this.imageCertificates.filter(
            (cretificate) =>
              cretificate.type === this.enumSignMethod.SIGN_USB_TOKEN
          ).length;
          this.isHaveDataSignMethodSIM_CA = !!this.imageCertificates.filter(
            (cretificate) =>
              cretificate.type === this.enumSignMethod.SIGN_SIM_CA
          ).length;
          this.isHaveDataSignMethodCLOUD_CA = !!this.imageCertificates.filter(
            (cretificate) => cretificate.type === this.enumSignMethod.CLOUD_CA
          ).length;
          // this.isHaveDataSignMethodEASY_CA = !!this.imageCertificates.filter(
          //   (cretificate) => cretificate.type === this.enumSignMethod.EASY_CA
          // ).length;
          // this.isHaveDataSignMethodOTP = !!this.imageCertificates.filter(
          //   (cretificate) => cretificate.type === this.enumSignMethod.SIGN_OTP
          // ).length;
        }  else {
          this.imageCertificates = [{
            type: this.enumSignMethod.CLOUD_CA,
            listCert: []
          }];
        
        //   this.indexSelect = 0;
        //   if (this.isDisplaySignatureTab(1)) {
        //     this.systemImageSign = true;
        //     this.isUploadImage = false;
        //     this.avatarUrl = null;
        //     this.convertHtmlToImage();
        //     this.cd.detectChanges();
        //     setTimeout(() => {
        //       this.setFontSize(imageConfigViewScaleId);
        //       this.setFontSize(imageConfigRenderId);
        //     }, 100);
        //   } else if (this.isDisplaySignatureTab(2)) {
        //     this.isUploadImage = true;
        //     this.isSelectDrawImage = false;
        //     this.systemImageSign = false;
        //     this.signatureFileDefault = null;
        //     this.canvasService.setCanvasSignatureImageUrl("");
        //     if (this.canvasComponent) {
        //       this.canvasComponent.clearCanvas();
        //     }
        //     this.avatarUrl = null;
        //   } else {
        //     this.isSelectDrawImage = true;
        //     this.systemImageSign = false;
        //     this.isUploadImage = false;
        //     this.imagePreviewWidth = 0;
        //     this.imagePreviewHeight = 0;
        //     this.canvasService.setCanvasSignatureImageUrl(
        //       this.signatureImageDraw
        //     );
        //     this.canvasService.setIsSelectSignDraw(true);
        //   }
        }
        if (this.imageCertificates.length > 0 && this.imageCertificates[0].listCert.length > 0) {
          this.selectedCert = this.imageCertificates[0].listCert[0];
          this.typeCertificate = this.selectedCert.typeCertificate;
          }
      });

  //     console.log('imageCertificates:', this.imageCertificates);
  // console.log('listCert[0]:', this.imageCertificates[0].listCert);
  }

  selectCertificate(event: any) {
    this.selectedCert = event;
  }

  getDisplayedColumns() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplay = this.columnDefinitions.map((cd) => cd.def);
        break;
    }
  }

  getDisplayedColumnsOTP() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP.map(
          (cd) => cd.def
        );
        break;
    }
  }

  getDisplayedColumnsCloudCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA.map(
          (cd) => cd.def
        );
        break;
    }
  }
  getDisplayedColumnsEasyCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA.map(
          (cd) => cd.def
        );
        break;
    }
  }

  

}
